import { getRuntimeConfig } from '../../app/runtimeConfig';

export interface ApiRequestOptions extends RequestInit {
  readonly path: string;
}

export async function apiRequest<T>(options: ApiRequestOptions): Promise<T> {
  const config = getRuntimeConfig();
  const headers = new Headers(options.headers);
  if (!headers.has('Content-Type') && options.body) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetch(`${config.apiBaseUrl}${options.path}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const errorText = await response.text();
    try {
      const errorPayload = JSON.parse(errorText) as { message?: string; code?: string };
      throw new Error(errorPayload.message || errorPayload.code || `API request failed: ${response.status}`);
    } catch {
      throw new Error(errorText || `API request failed: ${response.status}`);
    }
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return response.json() as Promise<T>;
}
